import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnDestroy,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ITrackingObject, I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-toggle',
  templateUrl: 'toggle.component.html',
  styleUrls: ['toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleComponent implements OnDestroy, OnChanges {
  @Input() fieldId: string;
  @Input() fieldControl: AbstractControl;
  @Input() toggleInputE2eId: string;
  @Input() toggleLabelE2eId: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingIdentifier: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingAdditionalProperties: any;

  @Output() toggleClick: EventEmitter<Event> = new EventEmitter<Event>();

  private _fieldSub: Subscription;
  private _destroyed = new Subject<boolean>();

  constructor(
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingDispatcher: TrackingDispatcher
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const trackingChanges =
      changes.fieldControl ||
      changes.trackingObject ||
      changes.trackingIdentifier ||
      changes.trackingScreenName;

    if (
      trackingChanges &&
      this.fieldControl &&
      this.trackingObject &&
      this.trackingIdentifier &&
      this.trackingScreenName
    ) {
      if (this._fieldSub) {
        this._fieldSub.unsubscribe();
      }

      this._fieldSub = this.fieldControl.valueChanges
        .pipe(distinctUntilChanged(), takeUntil(this._destroyed))
        .subscribe((value) => {
          const trackingAction = this._trackingActionBuilder.buildToggleTapped(
            this.trackingIdentifier,
            value,
            this.trackingScreenName
          );

          this._trackingDispatcher.trackEvent(
            this.trackingObject,
            trackingAction,
            this.trackingAdditionalProperties
          );
        });
    }
  }

  ngOnDestroy() {
    if (this._fieldSub) {
      this._fieldSub.unsubscribe();
    }

    this._destroyed.next(true);
  }
}
